import { createSlice } from "@reduxjs/toolkit";

const vinFromImage = createSlice({
    name: "vinImage",
    initialState: {
        vin: null,
        dataLoaded: false,
    },
    reducers: {
        getVinFromImage(state, _action) {
            return { ...state, dataLoaded: false };
        },
        setVinFromImage(state, action) {
            const vinData = Object.values(action.payload);
            return { ...state, vin: vinData, dataLoaded: true };
        },
    },
});

export const { getVinFromImage, setVinFromImage } = vinFromImage.actions;

export default vinFromImage.reducer;
